





















import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { NumericFilterObj } from "@/components/Filter/FilterGenerator";
import { getTranslationMixin } from "@/mixins/getTranslationMixin";
import { mapGetters } from "vuex";

export default {
  name: "NumericFilter",
  props: {
    item: NumericFilterObj
  },
  mixins: [getTranslationMixin],
  data() {
    return {
      value: [this.item.minValue, this.item.maxValue],
      isDragging: false
    };
  },
  components: {
    VueSlider
  },
  computed: {
    ...mapGetters(["refreshNumericFilters"])
  },
  methods: {
    onValueChanged() {
      if (!this.isDragging) {
        this.item.currentRange = this.value;
        this.$store.dispatch("addFilter", this.item);
      }
    },
    dragging() {
      // Zorgt ervoor dat de store niet bij elke value verandering moet updaten
      this.isDragging = true;
    },
    stopDragging() {
      this.isDragging = false;
      this.onValueChanged();
    },
    updateValue() {
      console.log("update filter");
      console.log(this.refreshNumericFilters);
      this.value = [this.item.minValue, this.item.maxValue];
      this.item.currentRange = [this.item.minValue, this.item.maxValue];
      this.$store.dispatch("numericRefreshed");
    }
  }
};
